import { deleteMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const DELETE_PATIENT_LIST = 'DELETE_PATIENT_LIST';
export const DELETE_PATIENT_LIST_SUCCESS = 'DELETE_PATIENT_LIST_SUCCESS';
export const DELETE_PATIENT_LIST_FAILURE = 'DELETE_PATIENT_LIST_FAILURE';

// Action Creators
export const deletePatientList = () => ({
  type: DELETE_PATIENT_LIST,
});

export const deletePatientListSuccess = (users) => ({
  type: DELETE_PATIENT_LIST_SUCCESS,
  payload: users,
});

export const deletePatientListFailure = (error) => ({
  type: DELETE_PATIENT_LIST_FAILURE,
  payload: error,
});

// Thunk Function
export const deletePatientData = (external, id) => {
  return async (dispatch) => {
    dispatch(deletePatientList());
    try {
      const response = await deleteMethodWithToken(url?.deleteList + id + '/');
      if (response?.status === 200 || response?.status === 201) {
        dispatch(deletePatientListSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
        dispatch(deletePatientListFailure('error?.message'));
      }
    } catch (error) {
      dispatch(deletePatientListFailure(error?.message));
    }
  };
};
